export default "__VITE_ASSET__B4Goai$B__"